"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardIndex = DashboardIndex;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var allocation_mismatch_alert_1 = require("../../components/allocation-mismatch-alert");
var nav_bar_1 = require("../../components/nav-bar");
var top_header_1 = require("../../components/top-header");
var hooks_1 = require("../../store/hooks");
function DashboardIndex() {
    var isNavbarCollapsed = (0, hooks_1.useAppSelector)(function (state) { return state.common; }).isNavbarCollapsed;
    var marginClass = isNavbarCollapsed ? "ml-16 md:ml-20" : "ml-64";
    /*
     * `min-w-0` on the content column, and `overflow-x-hidden` on the shell.
     *
     * A flex child defaults to `min-width: auto`, meaning it refuses to shrink below its contents. So any
     * page with something genuinely wide — a data table, a long unbroken sentence — stretched this column
     * and put a horizontal scrollbar under the ENTIRE app, sidebar included, clipping whatever sat at the
     * right-hand edge. It was fixed page by page as it cropped up, which only ever moved the problem to
     * the next screen that grew a wide element.
     *
     * Fixing it here makes it structural: a wide child now scrolls inside its own container, which is
     * what `overflow-auto` on that child was always meant to do.
     */
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-screen w-full overflow-x-hidden", children: [(0, jsx_runtime_1.jsx)(nav_bar_1.NavBar, {}), (0, jsx_runtime_1.jsxs)("div", { className: "flex min-w-0 flex-1 flex-col transition-all duration-300 ".concat(marginClass), children: [(0, jsx_runtime_1.jsx)(top_header_1.TopHeader, {}), (0, jsx_runtime_1.jsxs)("main", { className: "min-w-0 flex-1 overflow-auto bg-gray-50 p-2 pt-18 md:p-6 md:pt-20", children: [(0, jsx_runtime_1.jsx)(allocation_mismatch_alert_1.AllocationMismatchAlert, {}), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] })] })] }));
}
